import React, { useEffect, useState } from "react";
import ClientDetails from "./ClientDetails";
import { Client, Baby, Cohabitant } from "../requests";
import { useParams } from "react-router-dom";

const ClientShowPage = (props) => {
  const [client, setClient] = useState({});
  const [isLoading, setIsLoading] = useState(true)

  const { id } = useParams();

  const refresh = () => {
    Client.show(id).then((fetchedClient) => {
      setClient(fetchedClient);
    }).then(() => {
      setIsLoading(false)
    })
  };

  useEffect(() => {
    refresh();
  }, []);

  const createBaby = (params) => {
    Baby.create(id, params).then(() => {
      refresh();
    });
  };

  const createCohabitant = (params) => {
    Cohabitant.create(id, params).then(() => {
      refresh();
    });
  };

  const deleteBaby = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this baby? This action cannot be undone!"
      )
    ) {
      Baby.destroy(id).then(() => {
        refresh();
      });
    }
  };

  const deleteCohabitant = (id) => {
    if (
      window.confirm(
        "Are you sure you want to delete this cohabitant? This action cannot be undone!"
      )
    ) {
      Cohabitant.destroy(id).then(() => {
        refresh();
      });
    }
  };

  const totalHouseholdIncome = () => {
    return (
      Number(client.employment) +
      Number(client.social_services) +
      Number(client.child_tax_credit) +
      Number(client.support_maintenance) +
      Number(client.ei_benefits) +
      Number(client.wcb_benefits) +
      Number(client.pension) +
      Number(client.other_income)
    );
  };
  const totalHouseholdExpenses = () => {
    return (
      Number(client.room_and_board) +
      Number(client.rent) +
      Number(client.mortgage) +
      Number(client.property_insurance) +
      Number(client.property_taxes) +
      Number(client.strata) +
      Number(client.laundry) +
      Number(client.hydro) +
      Number(client.gas) +
      Number(client.cable) +
      Number(client.phone) +
      Number(client.internet) +
      Number(client.medical) +
      Number(client.car_payment) +
      Number(client.car_insurance) +
      Number(client.other_expenses)
    );
  };
  const totalHouseholdNetIncome = () => {
    return totalHouseholdIncome() - totalHouseholdExpenses();
  };

  if (isLoading) {
    return <div className="ClientShowPage">Loading...</div>
  }

  return (
    <>
      <div>
        <h1 className="text-center">Client details</h1>
        <ClientDetails
          currentUser={props.currentUser}
          createBaby={createBaby}
          deleteBaby={deleteBaby}
          createCohabitant={createCohabitant}
          deleteCohabitant={deleteCohabitant}
          babies={client.babies}
          cohabitants={client.cohabitants}
          id={id}
          first_name={client.first_name}
          last_name={client.last_name}
          dietary_restrictions={client.dietary_restrictions}
          languages={client.languages}
          comments={client.comments}
          family_size={client.family_size}
          new_client={client.new_client}
          end_date={client.end_date}
          cancelled_date={client.cancelled_date}
          interview_date={client.interview_date}
          date_of_birth={client.date_of_birth}
          address={client.address}
          city={client.city}
          postal_code={client.postal_code}
          phone_number={client.phone_number}
          email={client.email}
          start_date={client.start_date}
          last_visit={client.last_visit}
          employment={client.employment}
          social_services={client.social_services}
          child_tax_credit={client.child_tax_credit}
          support_maintenance={client.support_maintenance}
          ei_benefits={client.ei_benefits}
          wcb_benefits={client.wcb_benefits}
          pension={client.pension}
          room_and_board={client.room_and_board}
          rent={client.rent}
          mortgage={client.mortgage}
          property_insurance={client.property_insurance}
          property_taxes={client.property_taxes}
          strata={client.strata}
          laundry={client.laundry}
          hydro={client.hydro}
          gas={client.gas}
          phone={client.phone}
          cable={client.cable}
          internet={client.internet}
          medical={client.medical}
          car_payment={client.car_payment}
          car_insurance={client.car_insurance}
          other_income={client.other_income}
          other_expenses={client.other_expenses}
          admin_comment={client.admin_comment}
          release_signed={client.release_signed}
          totalHouseholdIncome={totalHouseholdIncome}
          totalHouseholdExpenses={totalHouseholdExpenses}
          totalHouseholdNetIncome={totalHouseholdNetIncome}
          setSmallPickUps={props.setSmallPickUps}
          setLargePickUps={props.setLargePickUps}
          getTodaysPickUps={props.getTodaysPickUps}
          holiday_meal={client.holiday_meal}
          holiday_visit={client.holiday_visit}
        />
      </div>
    </>
  );
};

export default ClientShowPage;
